import type { CampaignEditorValidationIssue } from '../../../campaign-editor/helpers/campaign-editor-validation';
import type { CampaignEditorSection } from '../../../campaign-editor/types';
import { getCampaignCreateFooterUsageLabel } from '../../../helpers/campaign-create-ux';

type CampaignEditFooterViewModelArgs = {
  campaignItemSlotLimit: number;
  isSubmitting: boolean;
  totalTrackedItems: number;
  validationIssue?: CampaignEditorValidationIssue;
  validationIssueCount: number;
};

export type CampaignEditFooterViewModel = {
  message: string;
  primaryDisabled: boolean;
  primaryLabel: string;
  usageLabel: string;
};

function getCampaignEditFooterMessage(
  campaignItemSlotLimit: number,
  issue?: CampaignEditorValidationIssue,
) {
  if (!issue) {
    return 'Save changes across edited sections.';
  }

  switch (issue.section) {
    case 'campaign-info':
      return 'Complete campaign details to continue';
    case 'tracking-items':
      return issue.reason === 'limit-exceeded'
        ? `Stay within the ${campaignItemSlotLimit} item limit to continue`
        : 'Add at least one creator or post URL';
    case 'creators':
      return 'Check creator details to continue';
    case 'post-urls':
      return 'Check post URL details to continue';
    default:
      return 'Complete campaign details to continue';
  }
}

export function getCampaignEditSectionForValidationIssue(
  issue: CampaignEditorValidationIssue,
): CampaignEditorSection {
  switch (issue.section) {
    case 'campaign-info':
      return 'campaign-info';
    case 'post-urls':
      return 'post-urls';
    case 'tracking-items':
    case 'creators':
    default:
      return 'creators';
  }
}

export function getCampaignEditFooterViewModel({
  campaignItemSlotLimit,
  isSubmitting,
  totalTrackedItems,
  validationIssue,
  validationIssueCount,
}: CampaignEditFooterViewModelArgs): CampaignEditFooterViewModel {
  return {
    message: getCampaignEditFooterMessage(campaignItemSlotLimit, validationIssue),
    primaryDisabled: validationIssueCount > 0 || isSubmitting,
    primaryLabel: 'Save changes',
    usageLabel: getCampaignCreateFooterUsageLabel({
      limit: campaignItemSlotLimit,
      usedCount: totalTrackedItems,
    }),
  };
}
